import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { Path } from 'config/portal'
import { ReviewNotificationMaterialsForm } from '../forms'
import * as apiActions from 'api-actions'
import { selectors } from '../reducer'
import { ComponentFailure } from 'components'

const propTypes = {
  participantsForSubmission: PropTypes.arrayOf(Types.rolloverParticipant)
    .isRequired,
  fetchRecordKeeperMaterials: PropTypes.func.isRequired,
  recordKeeperMaterials: Types.recordKeeperMaterials.isRequired,
}
const defaultProps = {}

function ReviewNotificationMaterialsView({
  fetchRecordKeeperMaterials,
  recordKeeperMaterials,
  participantsForSubmission,
}) {
  const history = useHistory()
  const location = useLocation()
  const [error, setError] = useState(false)
  const planStatuses = location.state?.planStatuses || []

  useEffect(() => {
    async function getRecordKeeperMaterials() {
      try {
        await fetchRecordKeeperMaterials()
      } catch {
        setError(true)
      }
    }
    getRecordKeeperMaterials()
  }, [])

  const handleSubmit = (values) => {
    // convert back to original recordkeeper name
    const desanitizeFieldName = (name) => name.replace(/__/g, '.')
    const submissionData = Object.keys(values).reduce((acc, key) => {
      const originalKey = desanitizeFieldName(key)
      acc[originalKey] = values[key]
      return acc
    }, {})
    const recordFiles = Object.entries(submissionData).reduce(
      (acc, [key, val]) => {
        if (val instanceof File) acc[key] = val
        return acc
      },
      {}
    )
    history.push({
      pathname: Path.REVIEW_AND_SUBMIT_NOTIFICATION_SERVICES,
      state: {
        search: history.location.state?.search,
        recordFiles,
      },
    })
  }
  if (error) return <ComponentFailure />

  return (
    <div className="card full-height notifica-materials-view">
      <div className="notification-materials-form-container">
        <div className="form-masthead">
          <h2>Complete the following instructions</h2>
          <p>
            Follow the steps to prepare and submit your participant notification
            materials.
          </p>
        </div>
        <hr />
        <div className="form-section">
          <ReviewNotificationMaterialsForm
            recordkeeperMaterials={recordKeeperMaterials}
            handleSubmit={handleSubmit}
            planStatuses={planStatuses}
            participantsForSubmission={participantsForSubmission}
          />
        </div>
      </div>
    </div>
  )
}

ReviewNotificationMaterialsView.propTypes = propTypes
ReviewNotificationMaterialsView.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    recordKeeperMaterials: selectors.recordKeeperMaterials(state),
    participantsForSubmission: selectors.participantsForSubmission(state),
  }
}

const mapDispatchToProps = {
  fetchRecordKeeperMaterials: apiActions.fetchRecordKeeperMaterials,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ReviewNotificationMaterialsView)
)
